<template>
  <div>
    <b-loading :is-full-page="true" :active.sync="isLoading"> </b-loading>
    <table class="ni-regulatory-affairs-table" id="ni-regulatory-affairs-table">
      <thead>
        <tr class="ra-header-row">
          <th>Line No.</th>
          <th class="select-checkbox-cell">
            <b-checkbox
              ref="selectAllChecked"
              v-model="selectAllChecked"
              type="is-info"
              size="is-large"
            ></b-checkbox>
          </th>
          <th
            v-for="columnData in regualtoryAffairsColumns"
            :key="columnData.id"
          >
            <label>{{ columnData.label }}</label>
          </th>
        </tr>
      </thead>
      <tbody class="ni-regulatory-affairs-body">
        <tr
          v-for="(row, index) in regulatoryAffairsRows"
          :key="row.id"
          :class="[
            row.ctrlCodeId ? 'row-' + row.ctrlCodeId : 'newRow',
            row.rejectedBy === loginNetworkId &&
            (row.apprvlStatus === 'R' || row.indStatus === 'Rejected')
              ? 'lock-partial-row'
              : '',
            row.rejectedBy !== loginNetworkId &&
            (row.apprvlStatus === 'R' || row.indStatus === 'Rejected')
              ? 'lock-row'
              : ''
          ]"
          v-bind="row"
          @click="onRowClick($event)"
          @change="
            !isLoading
              ? changeOnRegulatoryAffairsRow(
                  $event,
                  index,
                  row,
                  regualtoryAffairsColumns
                )
              : ''
          "
        >
          <ValidationObserver>
            <td class="item-checkbox">{{ row.lineNumber }}</td>
            <td class="select-checkbox-cell item-checkbox">
              <b-checkbox
                type="is-info"
                size="is-large"
                v-model="checkboxGroup"
                :native-value="row.genlQstnId"
              ></b-checkbox>
            </td>
            <td class="line-errors item-checkbox">{{ row.lineErrors }}</td>
            <td>
              <b-input
                ref="firstInput"
                type="text"
                class="vcat"
                :value="row.vcat"
                disabled="disabled"
              ></b-input>
            </td>
            <td>
              <b-input
                type="text"
                class="desc"
                :title="row.desc30"
                :value="row.desc30"
                disabled="disabled"
              ></b-input>
            </td>
            <td>
              <b-select
                class="msds"
                v-model="row.msds"
                :value="row.msds === undefined ? (row.msds = ' ') : row.msds"
                :tabindex="row.apprvlStatus === 'R' ? -1 : 0"
              >
                <option value=" "></option>
                <option value="99998">
                  99998
                </option>
                <option value="99999">
                  99999
                </option>
                <option value="00000">
                  00000
                </option>
              </b-select>
            </td>
            <td>
              <b-select
                v-model="row.dirShip"
                @input="updateHazChrg(row)"
                class="dirShip"
                :value="
                  row.dirShip === undefined ? (row.dirShip = ' ') : row.dirShip
                "
                disabled
              >
                <option value=" "></option>
                <option value="D">D - Direct Ship</option>
                <option value="E">E - Express Direct Ship</option>
                <option value="N">N - Not Direct Ship</option>
              </b-select>
            </td>
            <td class="item-status">
              <ValidationProvider
                rules="oneOf:Approved,Rejected"
                :bails="false"
                v-slot="{ classes }"
                immediate
                vid="indStatus"
              >
                <div class="control" :class="classes">
                  <b-select
                    v-model="row.indStatus"
                    class="apprvlStatus"
                    @input="
                      row.indStatus === 'Rejected'
                        ? (row.rejectedBy = loginNetworkId)
                        : (row.rejectedBy = '')
                    "
                    :tabindex="
                      row.rejectedBy !== loginNetworkId &&
                      (row.apprvlStatus === 'R' || row.indStatus === 'Rejected')
                        ? -1
                        : 0
                    "
                  >
                    <option value="Not Reviewed">Not Reviewed</option>
                    <option value="Approved">Approved</option>
                    <option value="Rejected">Rejected</option>
                  </b-select>
                </div>
              </ValidationProvider>
            </td>
            <td class="item-rejection-reason">
              <ValidationProvider
                rules="required_if:indStatus,Rejected"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-tooltip
                    :label="row.rejectionReason ? row.rejectionReason : ''"
                    type="is-light"
                    position="is-bottom"
                  >
                    <b-input
                      class="rejectionReason"
                      :value="row.rejectionReason"
                      @change.native="row.rejectionReason = $event.target.value"
                      :disabled="disableOnStatus(row)"
                      :tabindex="
                        row.rejectedBy !== loginNetworkId &&
                        (row.apprvlStatus === 'R' ||
                          row.indStatus === 'Rejected')
                          ? -1
                          : 0
                      "
                    ></b-input>
                  </b-tooltip>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                v-if="
                  loginRole === 3 &&
                    (row.apprvlStatus !== 'R' || row.indStatus !== 'Rejected')
                "
                rules="required"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <v-select
                    :filterable="false"
                    :options="bolOptions"
                    class="bol"
                    v-model="row.bolDesc"
                    @search="fetchBolValues"
                    @input="
                      changeOnRegulatoryAffairsRow(
                        $event,
                        index,
                        row,
                        regualtoryAffairsColumns
                      );
                      updateHazChrg(row);
                    "
                    :disabled="loginRole !== 3"
                    :tabindex="row.apprvlStatus === 'R' ? -1 : 0"
                  >
                    <template slot="option" slot-scope="bolOption">
                      <div class="d-center">
                        {{ bolOption.label }}
                      </div>
                    </template>
                    <template slot="selected-option" slot-scope="bolOption">
                      <div class="selected d-center">
                        {{ bolOption.label }}
                      </div>
                    </template>
                    <template
                      slot="no-options"
                      slot-scope="{ search, searching }"
                    >
                      <template v-if="searching">
                        Sorry, no matching options.
                      </template>
                      <span v-else class="display-none"></span>
                    </template>
                  </v-select>
                </div>
              </ValidationProvider>
              <v-select
                v-else
                :filterable="false"
                :options="bolOptions"
                class="bol"
                v-model="row.bolDesc"
                @search="fetchBolValues"
                @input="
                  changeOnRegulatoryAffairsRow(
                    $event,
                    index,
                    row,
                    regualtoryAffairsColumns
                  );
                  updateHazChrg(row);
                "
                :disabled="loginRole !== 3"
                :tabindex="row.apprvlStatus === 'R' ? -1 : 0"
              >
                <template slot="option" slot-scope="bolOption">
                  <div class="d-center">
                    {{ bolOption.label }}
                  </div>
                </template>
                <template slot="selected-option" slot-scope="bolOption">
                  <div class="selected d-center">
                    {{ bolOption.label }}
                  </div>
                </template>
                <template slot="no-options" slot-scope="{ search, searching }">
                  <template v-if="searching">
                    Sorry, no matching options.
                  </template>
                  <span v-else class="display-none"></span>
                </template>
              </v-select>
            </td>
            <td>
              <ValidationProvider
                v-if="row.apprvlStatus !== 'R' || row.indStatus !== 'Rejected'"
                rules="required"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-select
                    v-model="row.hazChrg"
                    class="hazChrg"
                    :value="
                      row.hazChrg === undefined
                        ? (row.hazChrg = ' ')
                        : row.hazChrg
                    "
                    :tabindex="row.apprvlStatus === 'R' ? -1 : 0"
                  >
                    <option value=" "></option>
                    <option value="P"
                      >P - Hazardous with a packing charge</option
                    >
                    <option value="H"
                      >H - Hazardous with no packing charge</option
                    >
                    <option value="NA">NA</option>
                  </b-select>
                </div>
              </ValidationProvider>
              <b-select
                v-else
                v-model="row.hazChrg"
                class="hazChrg"
                :value="
                  row.hazChrg === undefined ? (row.hazChrg = ' ') : row.hazChrg
                "
                :tabindex="row.apprvlStatus === 'R' ? -1 : 0"
              >
                <option value=" "></option>
                <option value="P">P - Hazardous with a packing charge</option>
                <option value="H">H - Hazardous with no packing charge</option>
                <option value="NA">NA</option>
              </b-select>
            </td>
            <td>
              <ValidationProvider
                rules="max:5"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-input
                    type="text"
                    oninput="this.value = this.value.replace(/[^\d]/g, '');"
                    class="ctrlCode1"
                    :class="row.ctrlCodeError1 ? 'invalid' : ''"
                    :value="row.ctrlCode1"
                    @change.native="row.ctrlCode1 = $event.target.value"
                    :tabindex="row.apprvlStatus === 'R' ? -1 : 0"
                  >
                  </b-input>
                  <b-tooltip
                    label="Control Code 1 maximum length is 5 characters in order to save this record"
                    type="is-danger"
                    position="is-top"
                  >
                    <b-icon
                      type="is-danger"
                      icon="alert-circle"
                      v-show="row.ctrlCode1 && row.ctrlCode1.length > 5"
                    >
                    </b-icon>
                  </b-tooltip>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                rules="max:5"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-input
                    type="text"
                    oninput="this.value = this.value.replace(/[^\d]/g, '');"
                    :class="row.ctrlCodeError2 ? 'invalid' : ''"
                    class="ctrlCode2"
                    :value="row.ctrlCode2"
                    @change.native="row.ctrlCode2 = $event.target.value"
                    :tabindex="row.apprvlStatus === 'R' ? -1 : 0"
                  ></b-input>
                  <b-tooltip
                    label="Control Code 2 maximum length is 5 characters in order to save this record"
                    type="is-danger"
                    position="is-top"
                  >
                    <b-icon
                      type="is-danger"
                      icon="alert-circle"
                      v-show="row.ctrlCode2 && row.ctrlCode2.length > 5"
                    >
                    </b-icon>
                  </b-tooltip>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                rules="max:5"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-input
                    type="text"
                    oninput="this.value = this.value.replace(/[^\d]/g, '');"
                    class="ctrlCode3"
                    :class="row.ctrlCodeError3 ? 'invalid' : ''"
                    :value="row.ctrlCode3"
                    @change.native="row.ctrlCode3 = $event.target.value"
                    :tabindex="row.apprvlStatus === 'R' ? -1 : 0"
                  ></b-input>
                  <b-tooltip
                    label="Control Code 3 maximum length is 5 characters in order to save this record"
                    type="is-danger"
                    position="is-top"
                  >
                    <b-icon
                      type="is-danger"
                      icon="alert-circle"
                      v-show="row.ctrlCode3 && row.ctrlCode3.length > 5"
                    >
                    </b-icon>
                  </b-tooltip>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                rules="max:5"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-input
                    type="text"
                    oninput="this.value = this.value.replace(/[^\d]/g, '');"
                    class="ctrlCode4"
                    :class="row.ctrlCodeError4 ? 'invalid' : ''"
                    :value="row.ctrlCode4"
                    @change.native="row.ctrlCode4 = $event.target.value"
                    :tabindex="row.apprvlStatus === 'R' ? -1 : 0"
                  ></b-input>
                  <b-tooltip
                    label="Control Code 4 maximum length is 5 characters in order to save this record"
                    type="is-danger"
                    position="is-top"
                  >
                    <b-icon
                      type="is-danger"
                      icon="alert-circle"
                      v-show="row.ctrlCode4 && row.ctrlCode4.length > 5"
                    >
                    </b-icon>
                  </b-tooltip>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <ValidationProvider
                rules="max:5"
                :bails="false"
                v-slot="{ classes }"
                immediate
              >
                <div class="control" :class="classes">
                  <b-input
                    type="text"
                    oninput="this.value = this.value.replace(/[^\d]/g, '');"
                    class="ctrlCode5"
                    :class="row.ctrlCodeError5 ? 'invalid' : ''"
                    :value="row.ctrlCode5"
                    @change.native="row.ctrlCode5 = $event.target.value"
                    :tabindex="row.apprvlStatus === 'R' ? -1 : 0"
                  ></b-input>
                  <b-tooltip
                    label="Control Code 5 maximum length is 5 characters in order to save this record"
                    type="is-danger"
                    position="is-top"
                  >
                    <b-icon
                      type="is-danger"
                      icon="alert-circle"
                      v-show="row.ctrlCode5 && row.ctrlCode5.length > 5"
                    >
                    </b-icon>
                  </b-tooltip>
                </div>
              </ValidationProvider>
            </td>
            <td>
              <b-input
                type="text"
                oninput="this.value = this.value.slice(0, 100);"
                class="key1"
                :value="row.key1"
                @change.native="row.key1 = $event.target.value"
                :tabindex="row.apprvlStatus === 'R' ? -1 : 0"
              ></b-input>
            </td>
            <td>
              <b-input
                type="text"
                oninput="this.value = this.value.slice(0, 100);"
                class="key2"
                :value="row.key2"
                @change.native="row.key2 = $event.target.value"
                :tabindex="row.apprvlStatus === 'R' ? -1 : 0"
              ></b-input>
            </td>
            <td>
              <b-input
                type="text"
                oninput="this.value = this.value.slice(0, 100);"
                class="key3"
                :value="row.key3"
                @change.native="row.key3 = $event.target.value"
                :tabindex="row.apprvlStatus === 'R' ? -1 : 0"
              ></b-input>
            </td>
            <td>
              <b-input
                type="text"
                oninput="this.value = this.value.slice(0, 100);"
                class="key4"
                :value="row.key4"
                @change.native="row.key4 = $event.target.value"
                :tabindex="row.apprvlStatus === 'R' ? -1 : 0"
              ></b-input>
            </td>
            <td>
              <b-input
                type="text"
                oninput="this.value = this.value.slice(0, 100);"
                class="key5"
                :value="row.key5"
                @change.native="row.key5 = $event.target.value"
                :tabindex="row.apprvlStatus === 'R' ? -1 : 0"
              ></b-input>
            </td>
            <td>
              <b-input
                type="text"
                oninput="this.value = this.value.slice(0, 100);"
                class="keyDesc1"
                :value="row.keyDesc1"
                @change.native="row.keyDesc1 = $event.target.value"
                :tabindex="row.apprvlStatus === 'R' ? -1 : 0"
              ></b-input>
            </td>
            <td>
              <b-input
                type="text"
                oninput="this.value = this.value.slice(0, 100);"
                class="keyDesc2"
                :value="row.keyDesc2"
                @change.native="row.keyDesc2 = $event.target.value"
                :tabindex="row.apprvlStatus === 'R' ? -1 : 0"
              ></b-input>
            </td>
            <td>
              <b-input
                type="text"
                oninput="this.value = this.value.slice(0, 100);"
                class="keyDesc3"
                :value="row.keyDesc3"
                @change.native="row.keyDesc3 = $event.target.value"
                :tabindex="row.apprvlStatus === 'R' ? -1 : 0"
              ></b-input>
            </td>
            <td>
              <b-input
                type="text"
                oninput="this.value = this.value.slice(0, 100);"
                class="keyDesc4"
                :value="row.keyDesc4"
                @change.native="row.keyDesc4 = $event.target.value"
                :tabindex="row.apprvlStatus === 'R' ? -1 : 0"
              ></b-input>
            </td>
            <td>
              <b-input
                type="text"
                oninput="this.value = this.value.slice(0, 100);"
                class="keyDesc5"
                :value="row.keyDesc5"
                @change.native="row.keyDesc5 = $event.target.value"
                :tabindex="row.apprvlStatus === 'R' ? -1 : 0"
              ></b-input>
            </td>
            <td>
              <b-select
                class="tsca6HPbt"
                :value="row.tsca6HPbt"
                disabled
                :tabindex="-1"
                ><option value=" "></option><option value="Y">Yes</option
                ><option value="N">No</option></b-select
              >
            </td>
            <td>
              <b-input
                class="raComments"
                :value="row.comments"
                @change.native="row.comments = $event.target.value"
                :tabindex="row.apprvlStatus === 'R' ? -1 : 0"
              ></b-input>
            </td>
          </ValidationObserver>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import $ from "jquery";
import vSelect from "vue-select";
import BSelect from "buefy/src/components/select/Select";
import BInput from "buefy/src/components/input/Input";
import { extend } from "vee-validate";
import * as rules from "vee-validate/dist/rules";
extend("required", {
  validate(value) {
    return {
      required: true,
      valid: [" ", "", null, undefined, 0].indexOf(value) === -1
    };
  },
  computesRequired: true
});

extend("regexUpto4Decimals", {
  validate(value) {
    return {
      required: true,
      valid: /^\d*\.?\d{0,4}$/.test(value)
    };
  },
  computesRequired: true
});

extend("regexUpto2Decimals", {
  validate(value) {
    return {
      required: true,
      valid: /^\d*\.?\d{0,2}$/.test(value)
    };
  },
  computesRequired: true
});

// extend("is_not_key1_duplicate", {
//   params: ["key2", "key3", "key4", "key5"],
//   validate(value, { key2, key3, key4, key5 }) {
//     return value !== key2 && value !== key3 && value !== key4 && value !== key5;
//   }
// });

Object.keys(rules).forEach(rule => {
  extend(rule, rules[rule]);
});

export default {
  name: "RegulatoryAffairsTabComponent",
  components: { BSelect, BInput, vSelect },
  data() {
    return {
      isLoading: false,
      selectAllChecked: false,
      checkboxGroup: [],
      selectedRows: [],
      generalQuestionRows: [],
      regulatoryAffairsRows: [],
      rowIds: [],
      paginationParams: [],
      bolOptions: [],
      regualtoryAffairsColumns: [
        { label: "Line Errors", col: "lineErrors" },
        { label: "Supplier Catalog Number", col: "vcat" },
        { label: "Item Description 30", col: "desc30" },
        { label: "Safety Data Sheet Code", col: "msds" },
        { label: "Direct Ship Indicator", col: "dirShip" },
        { label: "Approval Status", col: "indStatus" },
        { label: "Rejection Reason", col: "rejectionReason" },
        { label: "Bill Of Lading Code", col: "bolDesc" },
        { label: "Hazardous Item Charge ", col: "hazChrg" },
        { label: "Control Code 1", col: "ctrlCode1" },
        { label: "Control Code 2", col: "ctrlCode2" },
        { label: "Control Code 3", col: "ctrlCode3" },
        { label: "Control Code 4", col: "ctrlCode4" },
        { label: "Control Code 5", col: "ctrlCode5" },
        { label: "Keyword 1", col: "key1" },
        { label: "Keyword 2", col: "key2" },
        { label: "Keyword 3", col: "key3" },
        { label: "Keyword 4", col: "key4" },
        { label: "Keyword 5", col: "key5" },
        { label: "Keyword Description 1", col: "keyDesc1" },
        { label: "Keyword Description 2", col: "keyDesc2" },
        { label: "Keyword Description 3", col: "keyDesc3" },
        { label: "Keyword Description 4", col: "keyDesc4" },
        { label: "Keyword Description 5", col: "keyDesc5" },
        {
          label: "TSCA 6H PBT",
          col: "tsca6HPbt"
        },
        { label: "Comments", col: "comments" }
      ],
      loginRole: window.$cookies.get("ni_key")
        ? window.$cookies.get("ni_key").roleKey
        : 0,
      loginNetworkId: window.$cookies.get("ni_key")
        ? window.$cookies.get("ni_key").networkId
        : "",
      loginNameUser: window.$cookies.get("ni_key")
        ? window.$cookies.get("ni_key").nameUser
        : ""
    };
  },
  props: ["submissionIdForRegulatoryAffairs", "loadRegulatoryAffairsData"],
  watch: {
    selectAllChecked: function(isChecked) {
      if (isChecked) {
        this.checkboxGroup = this.rowIds;
      } else {
        this.checkboxGroup = [];
      }
      this.$emit("selectedRowIdsForRegulatoryAffairs", this.checkboxGroup);
    },
    checkboxGroup: function() {
      this.$emit("selectedRowIdsForRegulatoryAffairs", this.checkboxGroup);
    },
    loadRegulatoryAffairsData(value) {
      if (value.loadDetails) {
        this.generalQuestionRows = value.generalQuestionRows;
        this.actions = value.actions;
        this.paginationParams = value.paginationParams;
        if (value.validateRAData) {
          this.renderFromValidateObj(value.validateRAData);
        } else {
          this.loadRegulatoryAffairsUnderSubmission();
        }
      }
    }
  },
  methods: {
    onRowClick: function(event) {
      var tableRows = event.target.closest("tr").parentElement.rows;
      for (var row in tableRows) {
        if (
          tableRows[row].classList &&
          tableRows[row].classList.contains("highlight-row")
        ) {
          tableRows[row].classList.remove("highlight-row");
        }
      }
      event.target.closest("tr").classList.add("highlight-row");
    },
    changeOnRegulatoryAffairsRow(
      event,
      index,
      rowData,
      regualtoryAffairsColumns
    ) {
      var rowArrayFromResponse = JSON.parse(
        sessionStorage.getItem("regulatoryAffairsRows")
      );
      if (rowArrayFromResponse && rowArrayFromResponse.length > 0) {
        var rowDataFromResponseObj = JSON.parse(
          sessionStorage.getItem("regulatoryAffairsRows")
        )[index];
        for (var key in (rowDataFromResponseObj, rowData)) {
          if (
            key !== "psfsNewItemGenlQstnErrTbs" &&
            rowDataFromResponseObj[key] !== rowData[key]
          ) {
            if (
              !(
                rowDataFromResponseObj[key] === undefined &&
                rowData[key] === " "
              )
            ) {
              if (rowData[key] === " ") {
                rowData[key] = "";
              }
              rowData.updatedColumnName = key;
              rowData.updatedValue = rowData[key];
              for (let i = 0; i < regualtoryAffairsColumns.length; i++) {
                if (regualtoryAffairsColumns[i].col === key)
                  rowData.columnDesc = regualtoryAffairsColumns[i].label;
              }
              if (key.indexOf("ctrlCode") === 0) {
                if (rowData[key].length <= 5) {
                  this.updateRegulatoryAffairsItem(rowData, index);
                }
              } else {
                this.updateRegulatoryAffairsItem(rowData, index);
              }
              break;
            }
          }
        }
      }
    },
    loadRegulatoryAffairsUnderSubmission() {
      this.checkboxGroup = [];
      this.selectAllChecked = false;
      this.selectedRows = [];
      this.$emit("selectedRowIdsForRegulatoryAffairs", this.checkboxGroup);
      var scope = this;
      var args = {
        headers: {
          "content-type": "application/json"
        }
      };

      var requestPayload = {};
      requestPayload.actions = [];
      requestPayload.filterMap = {};
      requestPayload.searchMap = {};
      requestPayload.sortMap = {};
      if (this.actions.fErrors || this.actions.fLineErrors) {
        requestPayload.actions.push("Filter");
        if (this.actions.fErrors) {
          requestPayload.filterMap.ErroredItems = this.actions.fErrors;
        }
        if (this.actions.fLineErrors) {
          requestPayload.sortMap.lineErrors = this.actions.fLineErrors;
        }
      }

      scope.isLoading = true;
      scope.$http
        .post(
          `${process.env.VUE_APP_API_BASE_DOMAIN}ctrlCodes/submissionId/${scope.submissionIdForRegulatoryAffairs}?pageNbr=${scope.paginationParams.pageIndex}&pageSize=${scope.paginationParams.numberOfRAItems}`,
          requestPayload,
          args
        )
        .then(function(response) {
          var raPaginationParams = {
            startIndex: response.data.startIndex,
            endIndex: response.data.endIndex,
            totalCount: response.data.totalCount,
            totalPages: response.data.totalPages
          };
          scope.$emit("raPaginationParams", raPaginationParams);
          scope.$emit("raTabErrorCount", response.data.errorCount);
          scope.isLoading = false;
          scope.regulatoryAffairsRows = [];
          scope.rowIds = [];

          //enable/disable submit button
          if (
            scope.loginRole === 3 ||
            scope.loginRole === 4 ||
            scope.loginRole === 5
          ) {
            if (response.data.errorCount === 0) {
              //enable submit button
              scope.$emit("enableRAApproverSubmit", false);
            } else {
              //disable submit button
              scope.$emit("disableRAApproverSubmit", true);
            }
          }

          var mutableResponseRows = response.data.regulatoryAffairsDTOS;
          if (requestPayload.actions.length > 0) {
            if (response.data.regulatoryAffairsDTOS.length > 0) {
              for (
                var i = 0, lineNumber = raPaginationParams.startIndex;
                i < mutableResponseRows.length && lineNumber > 0;
                i++, lineNumber++
              ) {
                if (
                  !(
                    mutableResponseRows[i].rejectedBy !==
                      scope.loginNetworkId &&
                    (mutableResponseRows[i].apprvlStatus === "R" ||
                      mutableResponseRows[i].indStatus === "Rejected")
                  )
                ) {
                  scope.rowIds.push(mutableResponseRows[i].genlQstnId);
                }
                mutableResponseRows[i].lineNumber = lineNumber;
              }
              scope.regulatoryAffairsRows = mutableResponseRows;
              sessionStorage.setItem(
                "regulatoryAffairsRows",
                JSON.stringify(response.data.regulatoryAffairsDTOS)
              );
            } else {
              scope.regulatoryAffairsRows = [];
            }
          } else {
            if (response.data.regulatoryAffairsDTOS.length > 0) {
              for (
                var j = 0, lineNumberJ = raPaginationParams.startIndex;
                j < mutableResponseRows.length && lineNumberJ > 0;
                j++, lineNumberJ++
              ) {
                if (
                  !(
                    mutableResponseRows[j].rejectedBy !==
                      scope.loginNetworkId &&
                    (mutableResponseRows[j].apprvlStatus === "R" ||
                      mutableResponseRows[j].indStatus === "Rejected")
                  )
                ) {
                  scope.rowIds.push(mutableResponseRows[j].genlQstnId);
                }
                mutableResponseRows[j].lineNumber = lineNumberJ;
              }
              scope.regulatoryAffairsRows = mutableResponseRows;
              sessionStorage.setItem(
                "regulatoryAffairsRows",
                JSON.stringify(response.data.regulatoryAffairsDTOS)
              );
            } else {
              scope.regulatoryAffairsRows = [];
              sessionStorage.removeItem("regulatoryAffairsRows");
            }
          }
        })
        // eslint-disable-next-line no-unused-vars
        .catch(function(error) {
          scope.isLoading = false;
          scope.$buefy.snackbar.open({
            duration: 5000,
            message: `Failed to load items for Submission - ${scope.submissionIdForRegulatoryAffairs}. Please clear the cache and try again. If the problem persists, please contact the IT Support at NewItem.IT.Support@thermofisher.com`,
            type: "is-danger",
            position: "is-top",
            queue: false
          });
        })
        .then(function() {
          //focus on first editable msds field
          if (!$(".ni-app-regulatory-affairs-tab").hasClass("viewOnly")) {
            var firstEditableCell = $(".ni-regulatory-affairs-body")
              .children("tr:not(.lock-row)")
              .first();
            if (firstEditableCell.hasClass("lock-partial-row")) {
              firstEditableCell
                .find("td:has(.apprvlStatus select)")
                .find("select")
                .focus();
            } else {
              firstEditableCell
                .find("td:has(.msds select)")
                .find("select")
                .focus();
            }
          }

          //custom navigator plugin using jquery
          (function($) {
            $.fn.enableCellNavigation = function() {
              var arrow = {
                left: 37,
                up: 38,
                right: 39,
                down: 40
              };
              var esc = 27;

              // select all on focus
              // works for elements and will put focus into
              // adjacent input or select
              this.find("input,select").keydown(function(e) {
                // shortcut for key other than arrow keys
                if (
                  $.inArray(e.which, [
                    arrow.left,
                    arrow.up,
                    arrow.right,
                    arrow.down,
                    esc
                  ]) < 0
                ) {
                  return;
                }

                var input = e.target;
                var td = $(e.target).closest("td");
                var moveTo = null;

                switch (e.which) {
                  case arrow.left: {
                    if (
                      ($(input).is("input:text") &&
                        input.selectionStart !== 0) === false
                    ) {
                      //left on checkbox
                      if (td.index() === 1) {
                        //if lock-partial-row
                        if (
                          td
                            .parents("tr")
                            .prevAll("tr:not(.lock-row)")
                            .first()
                            .hasClass("lock-partial-row")
                        ) {
                          //go to rejectionReason field on lock-partial-row
                          moveTo = td
                            .parents("tr")
                            .prevAll("tr:not(.lock-row)")
                            .first("tr")
                            .find("td:has(.rejectionReason input)");
                        } else {
                          //go to raComments field
                          moveTo = td
                            .parents("tr")
                            .prevAll("tr:not(.lock-row):not(.lock-partial-row)")
                            .first("tr")
                            .find("td:has(.raComments input)");
                        }
                      }
                      //left on status
                      else if (td.index() === 7) {
                        //if lock-partial-row
                        if (td.parents("tr").hasClass("lock-partial-row")) {
                          //go to checbox field
                          moveTo = td.prevAll("td:has(input:checkbox)");
                        } else {
                          //go to msds field
                          moveTo = td.prevAll("td:has(.msds select)");
                        }
                      }
                      //left on input, select
                      else {
                        //if current filed disabled go to prev input, select that are not disabled
                        if (td.prev("td:has(input,select)").has(":disabled")) {
                          moveTo = td.prevAll(
                            "td:has(input:not(:disabled),select:not(:disabled))"
                          );
                          //if left on first field
                          if (moveTo.length === 0) {
                            //go to prev row last input
                            moveTo = td
                              .parents("tr")
                              .prevAll(
                                "tr:not(.lock-row):not(.lock-partial-row)"
                              )
                              .find("td")
                              .last("td.has(input)");
                          }
                        }
                        //else go to prev input
                        else {
                          moveTo = td.prev("td:has(input,select)");
                        }
                      }
                    }
                    break;
                  }
                  case arrow.right: {
                    if (
                      ($(input).is("input:text") &&
                        input.selectionStart !== input.value.length) === false
                    ) {
                      //right on checkbox field
                      if (td.index() === 1) {
                        //if lock-partial-row
                        if (
                          td
                            .parents("tr:not(.lock-row)")
                            .hasClass("lock-partial-row")
                        ) {
                          //go to status field
                          moveTo = td.nextAll("td:has(.apprvlStatus select)");
                        } else {
                          //else go to msds field
                          moveTo = td.nextAll("td:has(.msds select)");
                        }
                      } else if (td.index() === 8) {
                        //if lock-partial-row
                        if (td.parents("tr").hasClass("lock-partial-row")) {
                          //go to next row checkbox field
                          //skip lock-row
                          moveTo = td
                            .parents("tr")
                            .nextAll("tr:not(.lock-row)")
                            .find("td:has(input:checkbox)");
                        } else {
                          //go to msds field
                          moveTo = td.next("td:has(input,select)");
                        }
                      } else {
                        //right on input, select
                        if (td.next("td:has(input,select)").has(":disabled")) {
                          moveTo = td.nextAll(
                            "td:has(input:not(:disabled),select:not(:disabled))"
                          );
                          //if right on last field
                          if (moveTo.length === 0) {
                            //go to next row checkbox field
                            //skip lock-row
                            moveTo = td
                              .parents("tr")
                              .nextAll("tr:not(.lock-row)")
                              .find("td:has(input:checkbox)");
                          }
                        } else {
                          //else go to next cell
                          moveTo = td.next("td:has(input,select)");
                        }
                      }
                    }
                    break;
                  }

                  case arrow.up:
                  case arrow.down: {
                    e.preventDefault();
                    var tr = td.closest("tr");
                    var pos = td.index();

                    var moveToRow = null;
                    //skip over rejected rows on up/down
                    if (e.which == arrow.down) {
                      moveToRow = tr.nextAll(
                        "tr:not(.lock-partial-row):not(.lock-row)"
                      );
                    } else if (e.which == arrow.up) {
                      moveToRow = tr.prevAll(
                        "tr:not(.lock-partial-row):not(.lock-row)"
                      );
                    }

                    if (moveToRow.length) {
                      moveTo = $(moveToRow[0].children[0].children[pos]);
                    }
                    break;
                  }
                }

                if (moveTo && moveTo.length) {
                  e.preventDefault();
                  var input = $(moveTo[0]).find("input")[0];
                  if (arrow.right === e.which && $(input).is("input:text")) {
                    // var input = $(moveTo[0]).find("input")[0];
                    input.focus();
                    $(input)
                      .get(0)
                      .setSelectionRange(0, 0);
                  } else if (
                    arrow.left === e.which &&
                    $(input).is("input:text")
                  ) {
                    // var input = $(moveTo[0]).find("input")[0];
                    if (typeof input.selectionStart == "number") {
                      input.selectionStart = input.selectionEnd =
                        input.value.length;
                    } else if (typeof input.createTextRange != "undefined") {
                      var range = input.createTextRange();
                      range.collapse(false);
                      range.select();
                    }
                    input.focus();
                  } else if ($(input).is("input:text")) {
                    // var input = $(moveTo[0]).find("input")[0];
                    input.focus();
                  } else {
                    //focus on input, select
                    var input = $(moveTo[0]).find("input,select")[0];
                    input.focus();
                  }
                }
              });
            };
          })($);

          // use the plugin
          $(function() {
            $("#ni-regulatory-affairs-table").enableCellNavigation();
          });
        });
    },
    renderFromValidateObj(data) {
      var scope = this;
      var raPaginationParams = {
        startIndex: data.startIndex,
        endIndex: data.endIndex,
        totalCount: data.totalCount,
        totalPages: data.totalPages
      };
      scope.$emit("raPaginationParams", raPaginationParams);
      scope.$emit("raTabErrorCount", data.errorCount);
      scope.isLoading = false;
      scope.regulatoryAffairsRows = [];
      scope.rowIds = [];

      //enable/disable submit button
      if (
        scope.loginRole === 3 ||
        scope.loginRole === 4 ||
        scope.loginRole === 5
      ) {
        if (data.errorCount === 0) {
          //enable submit button
          scope.$emit("enableRAApproverSubmit", false);
        } else {
          //disable submit button
          scope.$emit("disableRAApproverSubmit", true);
        }
      }

      var mutableResponseRows = data.regulatoryAffairsDTOS;

      if (data.regulatoryAffairsDTOS.length > 0) {
        for (
          var i = 0, lineNumber = raPaginationParams.startIndex;
          i < mutableResponseRows.length && lineNumber > 0;
          i++, lineNumber++
        ) {
          if (
            !(
              mutableResponseRows[i].rejectedBy !== scope.loginNetworkId &&
              (mutableResponseRows[i].apprvlStatus === "R" ||
                mutableResponseRows[i].indStatus === "Rejected")
            )
          ) {
            scope.rowIds.push(mutableResponseRows[i].genlQstnId);
          }
          mutableResponseRows[i].lineNumber = lineNumber;
        }
        scope.regulatoryAffairsRows = mutableResponseRows;
        sessionStorage.setItem(
          "regulatoryAffairsRows",
          JSON.stringify(data.regulatoryAffairsDTOS)
        );
      } else {
        scope.regulatoryAffairsRows = [];
      }
    },
    updateRegulatoryAffairsItem(requestPayload, index) {
      var scope = this;
      var args = {
        headers: {
          "content-type": "application/json"
        }
      };
      requestPayload.updatedBy = scope.loginNameUser;

      var updatedRowData = {};
      var approverNetworkId = scope.loginNetworkId;

      /*      requestPayload.indStatus === "Rejected"
        ? (requestPayload.updatedBy = approverNetworkId)
        : "";*/

      for (var key in requestPayload) {
        var prop = "";
        prop = requestPayload[key];
        if (typeof prop === "string") {
          if (prop.trim() !== "") {
            updatedRowData[key] = requestPayload[key];
          }
        } else {
          updatedRowData[key] = requestPayload[key];
        }
      }

      scope.isLoading = true;
      scope.$http
        .put(
          `${process.env.VUE_APP_API_BASE_DOMAIN}regulatoryAffairs/update/submissionId/${scope.submissionIdForRegulatoryAffairs}`,
          updatedRowData,
          args
        )
        // eslint-disable-next-line no-unused-vars
        .then(function(response) {
          scope.isLoading = false;
          var apiRow = response.data;
          apiRow.lineNumber = scope.regulatoryAffairsRows[index].lineNumber;
          scope.regulatoryAffairsRows[index] = apiRow;
          var raRows = JSON.parse(
            sessionStorage.getItem("regulatoryAffairsRows")
          );
          raRows.splice(index, 1, response.data);
          sessionStorage.setItem(
            "regulatoryAffairsRows",
            JSON.stringify(raRows)
          );
          scope.$emit("raTabErrorCount", response.data.totalErrorCount);
          //enable/disable submit button
          if (
            scope.loginRole === 3 ||
            scope.loginRole === 4 ||
            scope.loginRole === 5
          ) {
            if (response.data.totalErrorCount === 0) {
              //enable submit button
              scope.$emit("enableRAApproverSubmit", false);
            } else {
              //disable submit button
              scope.$emit("disableRAApproverSubmit", true);
            }
          }
        })
        // eslint-disable-next-line no-unused-vars
        .catch(function(error) {
          scope.isLoading = false;
          scope.$buefy.snackbar.open({
            duration: 5000,
            message: `Failed to update item information for Submission - ${scope.submissionIdForRegulatoryAffairs}. Please clear the cache and try again. If the problem persists, please contact the IT Support at NewItem.IT.Support@thermofisher.com`,
            type: "is-danger",
            position: "is-top",
            queue: false
          });
        })
        .then(function() {
          var tableRows = document.querySelector(".ni-regulatory-affairs-body")
            .rows;
          for (var row in tableRows) {
            if (
              tableRows[row].classList &&
              tableRows[row].classList.contains("highlight-row")
            ) {
              tableRows[row].classList.remove("highlight-row");
            }
          }
          //add highlight-row class
          document
            .querySelector(".ni-regulatory-affairs-body")
            .rows[index].classList.add("highlight-row");
          //blur select event on active element wrt index
          if (
            document.activeElement.closest("tr") &&
            document.activeElement.closest("tr").rowIndex !== index + 1
          ) {
            document.activeElement.blur();
          }
        });
    },
    disableOnStatus(rowData) {
      if (rowData.indStatus === "Rejected") {
        return false;
      } else {
        return true;
      }
    },
    fetchBolValues(search, loading) {
      if (search.length > 0) {
        var scope = this;

        loading(true);
        scope.$http
          .get(
            `${process.env.VUE_APP_API_BASE_DOMAIN}regulatoryAffairs/ctrlCodes/${search}`
          )
          .then(function(response) {
            loading(false);
            scope.bolOptions = response.data;
          })
          // eslint-disable-next-line no-unused-vars
          .catch(function(error) {
            loading(false);
            scope.$buefy.dialog.alert({
              message: `Failed to load Bill of Lading Code. Please enter valid search criteria and/or clear the cache and try again. If the problem persists, please contact the IT Support at NewItem.IT.Support@thermofisher.com`,
              confirmText: "OK",
              type: "is-danger"
            });
          });
      }
    },
    updateHazChrg(rowData) {
      var isBolCode200 =
        rowData.bolDesc === "200-Dangerous Goods, suspected DG";
      if (isBolCode200) {
        switch (rowData.dirShip) {
          case "D":
            rowData.hazChrg = "H";
            return rowData;
          case "E":
            rowData.hazChrg = "H";
            return rowData;
          case "N":
            rowData.hazChrg = "P";
            return rowData;
        }
      } else {
        if (
          rowData.dirShip === "D" ||
          rowData.dirShip === "E" ||
          rowData.dirShip === "N"
        ) {
          rowData.hazChrg = "NA";
          return rowData;
        }
      }
    }
  }
};
</script>

<style scoped></style>
